<template>
  <div>
    <Banner fromType="case" />
    <section class="blue-bg">
      <div class="container case-list">
        <div v-for="item in caseList" :key="item.id" class="case-item">
          <NuxtLink :to="`/detail?type=case&id=${item.id}`">
            <img :src="item.imgUrl" :alt="item.name">
            <h4>{{item.name}}</h4>
          </NuxtLink>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { useHttpApi } from '~/composables/useApi'
import Banner from './compontents/banner.vue'
import { usePageSeo } from '~/composables/useSeo'

// 使用useHead替代usePageSeo避免middleware中的警告
usePageSeo({
  title: '案例中心-瀚易特信息技术股份有限公司',
  description: '瀚林愿案例中心展示全国多地中小学AI成长平台落地实践，涵盖心理干预、行为管理、体质健康、学业提升等场景，以真实数据验证平台成效。',
  keywords: '智慧校园、教育AI、精准教学、瀚易特、瀚林愿',
  url: 'cases'
})
interface Case {
  id: string
  name: string,
  imgUrl: string
}
const caseList = ref([] as Case[])
const { getCaseListApi } = useHttpApi()
const getCaseList = async () => {
  const res = await getCaseListApi(false)
  caseList.value = res?.data?.data
}

// 页面加载时获取数据
onMounted(() => {
  getCaseList()
})

</script>

<style scoped lang="scss">
@use "sass:color";
@use "~~/assets/scss/main.scss" as *;

.case-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 30px 0;
  gap: 35px;
  .case-item {
    width: 570px;
    text-align: center;
    background: #fff;
    border-radius: 10px;
    box-shadow: 0 0 10px rgba(0,0,0,0.1);
    overflow: hidden;
    cursor: pointer;
    transition: all 0.3s ease;
    &:hover {
      box-shadow: 0 0 20px rgba(0,0,0,0.2);
      transform: translateY(-5px);
    }
    img {
      width: 100%;
      height: 320px;
      object-fit: cover;
    }
    h4 {
      font-size: 18px;
      color: rgba(0,0,0,0.8);
      padding: 15px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  }
}

</style>